// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__GXR-r","open":"alert_open__YN-ma","red":"alert_red__KqMg9","green":"alert_green__A0aF1","yellow":"alert_yellow__zVumX"};